module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-164.1108ed0.woff2";